var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deal"},[_vm._v("\n  认购："+_vm._s(_vm.moment(_vm.followItem.subscribeTime).format("YYYY/MM/DD"))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }